function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Confirmation component
 * 
 */
import * as React from 'react';
import AlreadyPaid from '../../components/already-paid/AlreadyPaid';
import ErrorApp from '../../components/error-app/ErrorApp';
import ExpiredModal from '../../components/expired-modal/ExpiredModal';
import PersonalDetails from './personal-details/PersonalDetails';
import LicenceDetails from './licence-details/LicenceDetails';
import Progress from '../../components/progress/Progress';
import Postage from './postage/Postage';
import CostTable from './cost-table/CostTable';
import Footer from './footer/Footer';
import Contact from '../../components/contact/Contact';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { deleteAll } from '../../actions';
import { isOrderExpired } from '../../functions/orderExpiration';
import { SITE_CONTENT } from '../../reducers/content/Site.content';
import './Summary.scss';
import { DELIVERY_METHOD_PICK_UP_IN_STORE, STORES_API } from '../../data/Data';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Summary extends React.Component {
  constructor(props) {
    super(props);
    /**
     * Check if the order has expired (24 hours since creation)
     */
    _defineProperty(this, "checkExpiration", () => {
      const {
        application
      } = this.props;
      if (application?.created_at && isOrderExpired(application.created_at)) {
        this.setState({
          showExpiredModal: true
        });
      }
    });
    /**
     * Handle expired modal action - clear state and redirect to referrer
     */
    _defineProperty(this, "handleExpiredAction", () => {
      const {
        application,
        deleteAll
      } = this.props;
      deleteAll();
      window.location.href = application.referrer || '/';
    });
    _defineProperty(this, "getStores", () => {
      const {
        application,
        deliveryMethod,
        deliveryPickUpStore
      } = this.props;
      const {
        club
      } = application;

      // Only fetch stores if in-store pickup is selected
      if (deliveryMethod?.value !== DELIVERY_METHOD_PICK_UP_IN_STORE.value) {
        return;
      }
      fetch(`${STORES_API}/clubs/${club.id}/stores`).then(response => {
        if (response.status >= 400) {
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn(result));
          throw err;
        } else {
          return response.json();
        }
      }).then(result => {
        if (result?.data) {
          const clubStores = result.data;
          const selectedStore = clubStores.find(store => store.id === deliveryPickUpStore.value);
          this.setState({
            clubStores,
            selectedStore
          });
        }
      }).catch(error => {
        console.warn('Error fetching stores:', error);
      });
    });
    _defineProperty(this, "setCanPay", canPay => {
      this.setState({
        canPay
      });
    });
    const {
      licenceDelivery
    } = props.addresses;
    this.state = {
      canPay: licenceDelivery === 'Australian' ? true : false,
      clubStores: [],
      selectedStore: null,
      showExpiredModal: false
    };
  }
  componentDidMount() {
    this.checkExpiration();
    this.getStores();
  }
  render() {
    const {
      application,
      bugsnagClient,
      transaction,
      content,
      deliveryMethod,
      deliveryPickupPerson
    } = this.props;
    const {
      canPay,
      showExpiredModal
    } = this.state;
    const {
      id,
      submission_token
    } = application;
    const {
      contact
    } = content;
    switch (true) {
      case showExpiredModal:
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsx(ExpiredModal, {
            show: true,
            onAction: this.handleExpiredAction
          })]
        });
      case !id || !submission_token:
        return /*#__PURE__*/_jsx(ErrorApp, {
          bugsnagClient: bugsnagClient
        });
      case transaction.success:
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsx("section", {
            className: "form-container",
            children: /*#__PURE__*/_jsx("div", {
              className: "Summary",
              children: /*#__PURE__*/_jsx(AlreadyPaid, {})
            })
          })]
        });
      default:
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsxs("section", {
            className: "content-container Summary",
            children: [/*#__PURE__*/_jsx("div", {
              className: "page-description",
              children: "Review the information that you've provided to ensure it's all correct. Your International Driving Permit will be prepared based on the information displayed on this screen."
            }), /*#__PURE__*/_jsxs("h2", {
              children: ["Your details", /*#__PURE__*/_jsxs(Link, {
                className: "edit",
                to: "/details",
                children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                  icon: "pencil"
                }), " Edit"]
              })]
            }), /*#__PURE__*/_jsx(PersonalDetails, {}), /*#__PURE__*/_jsx("h2", {
              children: "Licence details"
            }), /*#__PURE__*/_jsx(LicenceDetails, {}), /*#__PURE__*/_jsx("h2", {
              children: deliveryMethod && deliveryMethod.value === DELIVERY_METHOD_PICK_UP_IN_STORE.value ? 'Pickup location and total cost' : 'Postage and total cost'
            }), deliveryMethod && deliveryMethod.value === DELIVERY_METHOD_PICK_UP_IN_STORE.value ? /*#__PURE__*/_jsx("p", {
              className: "no-margin",
              children: "Once your application is reviewed and approved, your permit will be ready for collection within 2 business days. You will receive a confirmation email when your permit is ready to collect from your selected store."
            }) : /*#__PURE__*/_jsx("p", {
              className: "no-margin",
              children: "Once your application is reviewed and approved, your permit will be dispatched within 3 business days in metropolitan areas. It may take longer for public holidays and regional delivery subject to Australia Post delivery times. You will receive a confirmation email with tracking details."
            }), /*#__PURE__*/_jsx(Postage, {
              bugsnagClient: bugsnagClient,
              setCanPay: this.setCanPay
            }), /*#__PURE__*/_jsx(CostTable, {
              selectedStore: this.state.selectedStore,
              deliveryPickupPerson: deliveryPickupPerson
            }), /*#__PURE__*/_jsx(Footer, {
              bugsnagClient: bugsnagClient,
              canPay: canPay
            })]
          }), /*#__PURE__*/_jsx(Contact, {
            ...contact
          })]
        });
    }
  }
}
_defineProperty(Summary, "defaultProps", {
  addresses: {
    licenceDelivery: 'Australian'
  },
  jest: false,
  transaction: {
    success: false
  },
  content: {
    ...SITE_CONTENT
  },
  deliveryMethod: {
    error: false,
    required: true,
    valid: true,
    value: ''
  },
  deliveryPickUpStore: {
    value: 0
  },
  deliveryPickupPerson: {
    value: ''
  }
});
const mapStateToProps = ({
  addresses,
  application,
  transaction,
  deliveryMethod,
  deliveryPickUpStore,
  deliveryPickupPerson
}) => {
  return {
    addresses,
    application,
    transaction,
    deliveryMethod,
    deliveryPickUpStore,
    deliveryPickupPerson
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteAll: () => {
      dispatch(deleteAll());
    }
  };
};
const VisibleSummary = connect(mapStateToProps, mapDispatchToProps)(Summary);
export default VisibleSummary;